module.exports = __webpack_public_path__ + "img/shzx.baca2e97.svg";